const jsonHeaders = (token) => ({
  "Content-Type": "application/json",
  "x-access-token": token,
});

export const COLUMN_PREFERENCES_ENDPOINT = "/MDM/User/ColumnPreferences";

export const fetchColumnPreferencesRequest = (serverUrl, token) =>
  fetch(`${serverUrl}${COLUMN_PREFERENCES_ENDPOINT}`, {
    headers: jsonHeaders(token),
  });

export const saveColumnPreferencesRequest = (serverUrl, token, activeColumnKeys) =>
  fetch(`${serverUrl}${COLUMN_PREFERENCES_ENDPOINT}`, {
    method: "PUT",
    headers: jsonHeaders(token),
    body: JSON.stringify({ active_column_keys: activeColumnKeys }),
  });
